import { render, staticRenderFns } from "./Treatment_Therapy_Summary.vue?vue&type=template&id=0bf38d84&scoped=true&"
import script from "./Treatment_Therapy_Summary.vue?vue&type=script&lang=js&"
export * from "./Treatment_Therapy_Summary.vue?vue&type=script&lang=js&"
import style0 from "./Treatment_Therapy_Summary.vue?vue&type=style&index=0&id=0bf38d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf38d84",
  null
  
)

export default component.exports